import { JsonObject, JsonProperty } from "json2typescript";
import { LocalDateTimeConverter } from "types";

export interface ApplicationNotification {
    id?: string;
    created?: Date;
    read?: boolean;
};

@JsonObject("StatusChangeNotification")
export class StatusChangeNotification implements ApplicationNotification {
    @JsonProperty("id", String)
    public id: string | undefined = undefined;
    @JsonProperty("created", LocalDateTimeConverter)
    public created: Date | undefined = undefined;
    @JsonProperty("read", Boolean)
    public read: boolean | undefined = undefined;
    @JsonProperty("requestId", String)
    public requestId: string | undefined = undefined;
    @JsonProperty("requestUid", String)
    public requestUid: string | undefined = undefined;
    @JsonProperty("previousStatus", String)
    public previousStatus: string | undefined = undefined;
    @JsonProperty("nextStatus", String)
    public nextStatus: string | undefined = undefined;
}
